module.exports = __webpack_public_path__ + "media/images/default/pages/public_science_2/6-e1536b6122bb3f6842deb4bb80ec1fea.jpg";